import React from "react";
import { Typography, Button, Box, Paper } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useNavigate, useParams } from "react-router-dom";
import {  IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TimeOut from '../../assets/timeOut.png'

const baseURL="https://api-prod.daalchini.co.in"
const defaultPgName = localStorage.getItem("defaultPgName");

const IncorrectResponseBox = () => {
const navigate=useNavigate()
const {orderId}=useParams()
  const onClose=()=>{
    navigate(`/vendOrder/number/${orderId}`, { replace: true });
  }

  const handleClose=()=>{
    // navigate(`/pickupOptions/${orderId}`)
      navigate(`/activeOrder/true/${orderId}`, { replace: true });
  }

const MyHeader = () => {
  return (

             <Box
        sx={{
          bgcolor: "#fae14b",
          p: 1.5,
          display: "flex",
          alignItems: "center",
              position: "fixed",
    width: "100%"
        }}
      >
        <IconButton size="small" sx={{ mr: 1 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Match The Number
        </Typography>
      </Box>

  );
};


  return (
    <>
    <MyHeader/>
    <Box
      sx={{
        height: "100vh", // full screen height
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff", // optional background
      }}
    >
      <Paper
        elevation={3}
        sx={{
          borderRadius: "12px",
          border: "1px solid #f29f05",
          textAlign: "center",
          p: 3,
          width: "100%",
          maxWidth: 300,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
         <img src={TimeOut} style={{width:"90px",marginBottom:"20px"}}/>
          <Typography
            variant="h6"
            sx={{ color: "#f29f05", fontWeight: 600, mb: 3 }}
          >
        Session Timed Out
          </Typography>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              borderColor: "#f29f05",
              color: "#f29f05",
              fontWeight: 600,
              px: 4,
              "&:hover": {
                borderColor: "#f29f05",
                backgroundColor: "rgba(242,159,5,0.1)",
              },
            }}
          >
            CANCEL
          </Button>
        </Box>
      </Paper>
    </Box>
    </>
  );
};

export default IncorrectResponseBox;
